const IncomingFeatureTag = (): JSX.Element => {
  return (
    <span className="inline-flex items-center rounded-md bg-primary ms-1 px-1 py-0 text-[0.4rem] font-medium text-white max-h-[30px]">
      Coming Soon
    </span>
  );
};

export default IncomingFeatureTag;
